<template>
  <button @click="handleClick" class="nav-button" data-aos-offset="-2000">
    <div class="nav-button_title">{{ title }}</div>
    <div class="nav-button_subtitle">{{ subtitle }}</div>
  </button>
</template>

<script>
export default {
  name: "NavButton",
  props: {
    title: {
      type: String,
      default: ""
    },
    subtitle: {
      type: String,
      default: ""
    }
  },

  methods: {
    handleClick() {
      this.$emit("click");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/breackpoints.scss";

.nav-button {
  position: relative;
  padding: 15px 17px;
  width: 275px;
  flex-direction: column;
  color: #ffffff;
  text-transform: uppercase;
  background-color: rgba(#0e9244, 0.75);
  z-index: 1;

  @media (max-width: $xl) {
    width: 250px;
    padding: 10px 10px;
  }

  @media (max-width: $lg) {
    width: 228px;
    padding: 10px 10px;
  }

  @media (max-width: $lg) {
    height: max-content;
  }

  @media (max-width: $sm) {
    width: 100%;
    align-items: center;
  }

  &:first-of-type {
    color: #0e9244;
    background-color: rgba(#ffffff, 0.75);

    &::after {
      background-color: rgba(#ffffff, 0.5);
    }

    &:active {
      background-color: rgba(#ffffff, 0.9);
    }
  }

  &:hover {
    &::after {
      width: 100%;
    }
  }

  &:active {
    background-color: rgba(#0e9244, 0.9);
  }

  &::after {
    position: absolute;
    content: "";
    top: 0;
    left: 0;
    width: 0;
    height: 100%;
    background-color: rgba(#0e9244, 0.5);
    z-index: -1;
    transition: 0.25s ease;
  }

  &:not(:last-of-type) {
    margin-bottom: 1px;

    @media (max-width: $md) {
      margin-bottom: 0;
      margin-right: 15px;
    }

    @media (max-width: $sm) {
      margin: 0;
      margin-bottom: 2px;
    }
  }

  &_title {
    font-size: 22px;
    font-weight: 800;

    @media (max-width: $lg) {
      font-size: 20px;
    }
  }

  &_subtitle {
    font-size: 11px;

    @media (max-width: $lg) {
      font-size: 11px;
    }
  }
}
</style>
